import * as Sentry from "@sentry/react";

/**
 * Initialise Sentry si la DSN est fournie via VITE_SENTRY_DSN.
 * Pas de DSN → pas de report (no-op). Pratique en dev.
 *
 * Pour activer :
 *   1. Crée un compte sur sentry.io (gratuit)
 *   2. Crée un projet "React" → copie la DSN
 *   3. Ajoute VITE_SENTRY_DSN=https://xxx@yyy.ingest.sentry.io/zzz dans .env
 *   4. Redémarre Vite (ou redeploy Vercel)
 */
export function initSentry() {
  const dsn = import.meta.env.VITE_SENTRY_DSN;
  if (!dsn) return;

  Sentry.init({
    dsn,
    environment: import.meta.env.MODE, // "development" | "production"
    // Doit matcher le `release.name` du sentryVitePlugin (vite.config.ts).
    // Permet à Sentry d'associer une erreur runtime → release → source maps
    // → stack trace lisible. Vide en local → release "default".
    release: import.meta.env.VITE_VERCEL_GIT_COMMIT_SHA || undefined,
    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.replayIntegration({
        maskAllText: true,
        blockAllMedia: true,
      }),
    ],
    // Performance Monitoring — 10% des requêtes tracées
    tracesSampleRate: 0.1,
    // Replay — 10% des sessions enregistrées, 100% si erreur
    replaysSessionSampleRate: 0.1,
    replaysOnErrorSampleRate: 1.0,
    // Ignore les erreurs courantes du dev (HMR, extensions navigateur…)
    ignoreErrors: [
      "ResizeObserver loop limit exceeded",
      "Non-Error promise rejection captured",
    ],
  });
}
